<template>
  <div>
    VUE_APP_ENV_NAME
    <label>
      <input type="radio" v-model="state.VUE_APP_ENV_NAME" :value="'stater'"/>
      stater
    </label>
    <label>
      <input type="radio" v-model="state.VUE_APP_ENV_NAME" :value="'grok'"/>
      grok
    </label>
  </div>
  <div>
    VUE_APP_DEFAULT_LANGUAGE
    <label>
      <input type="radio" v-model="state.VUE_APP_DEFAULT_LANGUAGE" :value="'ru'"/>
      ru
    </label>
    <label>
      <input type="radio" v-model="state.VUE_APP_DEFAULT_LANGUAGE" :value="'en'"/>
      en
    </label>
  </div>
</template>
<script setup>
import {reactive, watch} from 'vue'

const state = reactive({
  VUE_APP_ENV_NAME: localStorage.getItem('VUE_APP_ENV_NAME'),
  VUE_APP_DEFAULT_LANGUAGE: localStorage.getItem('VUE_APP_DEFAULT_LANGUAGE'),
})

watch(state, () => {
  Object.keys(state).forEach(key => {
    localStorage.setItem(key, state[key])
  })
})

</script>

<style scoped>
label {
  display: block;
}

</style>
